module.exports = __webpack_public_path__ + "22930b997ab43a0a9f45332bd45db070.svg";